// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2PTmj","label":"Category_label__3fi6b","content":"Category_content__2IO4v","header":"Category_header__3OX3W","location":"Category_location__3x6Ts"};